import {Component, Host, h, Prop} from '@stencil/core';

@Component({
  tag: 'nest-table',
  styleUrl: 'nest-table.css',
  shadow: true,
})
export class NestTable {
  @Prop() columns: {name: string, label: string, cls?: string}[]
  @Prop() dataSource: any[]

  render() {
    return (
      <Host>
        <div class="flex flex-col">
          <div class="-m-1.5 overflow-x-auto">
            <div class="p-2 min-w-full inline-block align-middle">
              <div class="rounded overflow-hidden">
                <table class="min-w-full">
                  <thead class="bg-gray-100">
                  <tr>
                    {this.columns.map(column => (
                      <th scope="col"
                          class={`px-6 py-4 text-start text-xs font-bold uppercase ${column['cls']}`}>{column['label']}</th>
                    ))}
                    <th scope="col" class="px-6 py-3 text-end text-xs font-bold uppercase"></th>
                  </tr>
                  </thead>

                  <tbody class=" divide-y divide-gray-150">

                  {this.dataSource.map(data => (
                    <tr>
                      {this.columns.map(column => (
                        <td class={`px-6 py-6 whitespace-nowrap ${column['cls']}`}>
                          <div>{data[column['name']]}</div>
                        </td>
                      ))}
                      <td class="px-6 py-6 whitespace-nowrap text-end text-sm text-blue-600 w-10">
                        <nest-icon name="chevron-right" class="w-6 cursor-pointer"/>
                      </td>
                    </tr>
                  ))}

                  {!this.dataSource.length && (
                    <tr>
                      <td class='text-center py-6' colSpan={9999}>Loading..</td>
                    </tr>
                  )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </Host>
    );
  }

}
